export default function CaregiverJobHero() {
  return (
    <section className="relative w-full h-[560px] md:h-[640px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Professional%20Korean%20caregiver%20in%20a%20soft%20sage%20green%20uniform%20warmly%20holding%20hands%20with%20a%20smiling%20elderly%20patient%20in%20a%20bright%20modern%20hospital%20room%2C%20gentle%20natural%20window%20light%2C%20clean%20minimal%20interior%20with%20subtle%20green%20and%20white%20tones%2C%20trustworthy%20caring%20atmosphere%2C%20editorial%20healthcare%20photography%20with%20soft%20shadows%20and%20harmonious%20composition%2C%20high%20detail&width=1600&height=900&seq=cgjob-hero-01&orientation=landscape"
        alt="간병인으로 일하는 전문 간병인과 환자의 따뜻한 모습"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/60"></div>

      <div className="relative w-full h-full max-w-5xl mx-auto px-6 flex flex-col items-center justify-center text-center">
        <span
          className="inline-flex items-center gap-2 text-xs font-bold tracking-widest uppercase px-4 py-1.5 rounded-full mb-6 text-white border border-white/40 bg-white/10 backdrop-blur-sm"
        >
          <i className="ri-briefcase-line text-sm"></i>
          Caregiver Job · 간병인 모집
        </span>

        <h1 className="text-3xl md:text-5xl font-bold text-white leading-tight mb-4">
          간병인으로 일하고 싶으신가요?
        </h1>
        <p className="text-lg md:text-2xl font-semibold text-white/95 mb-2">
          코리아케어러스에 간병인으로 미리 등록하세요.
        </p>
        <p className="text-sm md:text-base text-white/80 leading-relaxed max-w-2xl mb-8">
          원하는 지역과 근무조건에 맞는 간병 일자리가 발생하면 안내드립니다.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 mb-8">
          <a
            href="#caregiver-register"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-xl text-base font-bold text-white whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
            style={{ backgroundColor: '#2E7D6B' }}
          >
            <i className="ri-user-add-line text-lg"></i>
            간병인 무료 등록하기
          </a>
          <span className="inline-flex items-center gap-2 px-5 py-3.5 rounded-xl text-sm font-semibold text-white whitespace-nowrap border border-white/40 bg-black/20 backdrop-blur-sm">
            <i className="ri-check-double-line text-lg"></i>
            등록비 무료 · 원하는 일자리 선택
          </span>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          {['병원간병', '재택간병', '단기간병', '장기간병', '24시간 간병'].map((t) => (
            <span key={t} className="inline-flex items-center gap-1.5 text-xs md:text-sm font-medium text-white/90">
              <i className="ri-check-line text-base" style={{ color: '#6fcfb8' }}></i>
              {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}